import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";
import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as componentTypes from "../constants/componentTypes";
import * as validationHelper from "../helpers/validationHelper";

const loadFormulas = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SAVE_SPECTRO_MEASURE_RESULT),
        switchMap(({payload}) => {
            if (payload.result === null || payload.result.lab.length !== 3) {
                return [
                    {
                        type: actionTypes.SAVE_SPECTRO_FORMULAS,
                        payload: {
                            params: {
                                formulas: []
                            }
                        }
                    }
                ];
            }

            let searchActions = [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_COLORS_BY_SPECTRO_DELTA,
                        params: {
                            delta: state$.value.module.redlikeSoftware ? state$.value.spectroTab.deltaFilter : null,
                            products: state$.value.spectroTab.productFilter,
                            fandecks: state$.value.spectroTab.fandeckFilter,
                            labl: payload.result.lab[0],
                            laba: payload.result.lab[1],
                            labb: payload.result.lab[2]
                        }
                    },
                    method: handlers.GET_COLORS_BY_SPECTRO_DELTA,
                    tabId: componentTypes.MODAL_NO_TAB
                }
            ];

            if (state$.value.module.gammaSoftware) {
                searchActions.push({
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.SEARCHING_MODAL,
                        params: {
                            message: translate("help.searchingPleaseWait"),
                            onCancel: {
                                type: actionTypes.SKIP_WEBSOCKET_REQUEST,
                                payload: {
                                    tabId: componentTypes.MODAL_NO_TAB,
                                    method: handlers.GET_COLORS_BY_SPECTRO_DELTA
                                }
                            }
                        }
                    }
                });
            }

            return searchActions;
        })
    );

const setDeltaFilter = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SPECTRO_SET_DELTA_FILTER),
        switchMap(({payload}) => {
            if (state$.value.spectroTab.deltaFilter === payload.delta) {
                return [];
            }

            return [
                {
                    type: actionTypes.SPECTRO_SAVE_DELTA_FILTER,
                    payload: {
                        delta: payload.delta
                    }
                }
            ];
        })
    );

const setFandeckFilter = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SPECTRO_SET_FANDECK_FILTER),
        switchMap(({payload}) => {
            if (validationHelper.isListChanged(state$.value.spectroTab.fandeckFilter, payload.fandecks)) {
                return [
                    {
                        type: actionTypes.SPECTRO_SAVE_FANDECK_FILTER,
                        payload: {
                            fandecks: payload.fandecks
                        }
                    }
                ];
            }

            return [];
        })
    );

const setProductFilter = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SPECTRO_SET_PRODUCT_FILTER),
        switchMap(({payload}) => {
            if (validationHelper.isListChanged(state$.value.spectroTab.productFilter, payload.products)) {
                return [
                    {
                        type: actionTypes.SPECTRO_SAVE_PRODUCT_FILTER,
                        payload: {
                            products: payload.products
                        }
                    }
                ];
            }

            return [];
        })
    );

const filterFormulas = (action$, state$) =>
    action$.pipe(
        ofType(
            actionTypes.SPECTRO_SAVE_FANDECK_FILTER,
            actionTypes.SPECTRO_SAVE_PRODUCT_FILTER,
            actionTypes.SPECTRO_SAVE_DELTA_FILTER
        ),
        switchMap(() => {
            if (state$.value.navigation.activeTabType !== componentTypes.SPECTRO_TAB) {
                return [];
            }

            return [{type: actionTypes.SPECTRO_RELOAD_SEARCH_RESULT}];
        })
    );

const reloadSearchResult = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SPECTRO_RELOAD_SEARCH_RESULT),
        switchMap(() => {
            if (state$.value.navigation.activeTabType !== componentTypes.SPECTRO_TAB) {
                return [];
            }

            let searchActions = [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_COLORS_BY_SPECTRO_DELTA,
                        params: {
                            delta: state$.value.module.redlikeSoftware ? state$.value.spectroTab.deltaFilter : null,
                            products: state$.value.spectroTab.productFilter,
                            fandecks: state$.value.spectroTab.fandeckFilter,
                            labl: state$.value.spectro.spectro.result.lab[0],
                            laba: state$.value.spectro.spectro.result.lab[1],
                            labb: state$.value.spectro.spectro.result.lab[2]
                        }
                    },
                    method: handlers.GET_COLORS_BY_SPECTRO_DELTA,
                    tabId: 0
                }
            ];

            if (state$.value.module.gammaSoftware) {
                searchActions.push({
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: componentTypes.MODAL_NO_TAB,
                        type: componentTypes.SEARCHING_MODAL,
                        params: {
                            message: translate("help.searchingPleaseWait"),
                            onCancel: {
                                type: actionTypes.SKIP_WEBSOCKET_REQUEST,
                                payload: {
                                    tabId: componentTypes.MODAL_NO_TAB,
                                    method: handlers.GET_COLORS_BY_SPECTRO_DELTA
                                }
                            }
                        }
                    }
                });
            }

            return searchActions;
        })
    );

export default [loadFormulas, setDeltaFilter, setFandeckFilter, setProductFilter, filterFormulas, reloadSearchResult];
